// Official Paranormal Archetypes social accounts. These open externally.

export const SOCIAL_LINKS = [
  { key: 'facebook', label: 'Facebook', icon: 'facebook', iconSet: 'fa5', url: 'https://www.facebook.com/61585515645044/' },
  { key: 'instagram', label: 'Instagram', icon: 'instagram', iconSet: 'fa5', url: 'https://instagram.com/ParanormalArchetypes' },
  { key: 'tiktok', label: 'TikTok', icon: 'tiktok', iconSet: 'fa5', url: 'https://www.tiktok.com/@paraarchetypes' },
  { key: 'youtube', label: 'YouTube', icon: 'youtube', iconSet: 'fa5', url: 'https://youtube.com/@ParanormalArchetypes' },
];

export const getActiveSocialLinks = () =>
  SOCIAL_LINKS.filter((l) => !!l.url && l.url.trim().length > 0);
